export default __webpack_public_path__ + "static/news-img-bg-10dc24f5e30b1df1fa1a97f936b9916d.png";